import { qidaApi } from 'yxt-biz-pc/packages/api';

// 获取岗位列表
export const getAuthSelectData = (params) => {
  return qidaApi.get('data/auth/user/select', {
    params
  });
};
